export enum Rubro {
  Comercios = 1,
  Servicios = 2,
  Industrias = 3,
}
export const RubroNombre: Record<Rubro, string> = {
    [Rubro.Comercios]: 'Comercios',
    [Rubro.Servicios]: 'Servicios',
    [Rubro.Industrias]: 'Industrias',
};
export function getNombreRubro(id: number): string {
  return RubroNombre[id as Rubro] || 'Desconocido';
}
export function getRubrosIds(socio_rubro?: number | null, socio_rubros?: string | null): number[] {
  const set = new Set<number>();
  if (socio_rubro) set.add(Number(socio_rubro));
  String(socio_rubros || '')
    .split(',')
    .forEach((part) => {
      const n = Number(part.trim());
      if (!Number.isNaN(n) && n > 0) set.add(n);
    });
  return Array.from(set);
}
export function getRubrosNombres(socio_rubro?: number | null, socio_rubros?: string | null): string {
  const ids = getRubrosIds(socio_rubro, socio_rubros);
  return ids.length ? ids.map((id) => getNombreRubro(id)).join(', ') : '';
}